import { useSignups } from "Signups/state.js";

export function useCalculateNumberOfUnpaidSlots() {
  const [{ userSignupItems }] = useSignups();

  if (!userSignupItems || Object.keys(userSignupItems).length < 1) return 0;

  let count = 0;
  Object.keys(userSignupItems).forEach((ID) => {
    userSignupItems[ID].respondents.forEach((respondent) => {
      if (respondent.paymentStatus === "Unpaid") count++;
    });
  });

  return count;
}
